import {Fab, IconButton, Paper, Slide, Typography, Box} from "@mui/material";
import {ChatBubble, Close} from "@mui/icons-material";
import * as React from "react";
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import Button from "@mui/material/Button";
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import {useState} from "react";


export const Chatbot = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const toggleChat = () => {
        setIsChatOpen(!isChatOpen);
    };
    return <>
        <Button color={'info'} variant={'outlined'} onClick={toggleChat} startIcon={<HeadsetMicOutlinedIcon color={'info'}/>} size={'medium'}>
            <Typography color={'info'}> AI 知识助手</Typography>
        </Button>

        <Slide direction="up" in={isChatOpen} mountOnEnter unmountOnExit>
            <Paper
                elevation={1}
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    // border: '1px solid #eee',
                    right: 18,
                    width: {xs: '100%', sm: 380},
                    height: {xs: 'calc(100% - 124px)', sm: 620},
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: {xs: '16px 16px 0 0', sm: '16px'},
                    boxSizing: 'border-box',
                    zIndex: 999,
                }}
            >
                {/* 聊天窗口头部 */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        py: 0.6,
                        px: 1.2,
                        bgcolor: '#fff',
                        borderTopLeftRadius: {xs: '16px', sm: '16px'},
                        borderTopRightRadius: {xs: '16px', sm: '16px'},
                    }}
                >
                    <Typography fontWeight={500} variant="h6">AI 知识助手</Typography>
                    <IconButton onClick={() => toggleChat()} color="inherit">
                        <Close color={"action"}/>
                    </IconButton>
                </Box>
                <Box component={'iframe'} src={"https://chat.kedaip.cn/#/chat/h5?robot_key=2NXP2MMEUj"} width="100%"
                     height="100%" style={{border: 'none'}}></Box>
            </Paper>
        </Slide></>
}